<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import ThisForm from "../../../components/payroll/salaryexportrecord/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": ThisForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('allsalaryexportrecord.createnewsalaryexportrecord'),
      pageTitleValue: "",
      formData: {
        salexpreccode: null,
        salexprecdesc: null,
        salexpyear: null,
        salexpmonth: null,
        bankaccountid: null,
        saleexportrecorddetail: [],
        stamp: 0,
        userid: this.$store.getters.userId,
        saleexportrecordref: [],
        status: null,
        statustimestamp: null
      },

      monthList: [],
      yearList: [],

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      this.$store.dispatch('post', {url: "/salaryexportrecord/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "salaryexportrecordlist" });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "salaryexportrecordlist" });
    },
  },
};
</script>